import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { QuoteModal } from "./components/QuoteModal";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Services from "./pages/Services";
import WhyChooseUs from "./pages/WhyChooseUs";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";

function App() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const handleQuoteClick = () => {
    setIsQuoteModalOpen(true);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Header onQuoteClick={handleQuoteClick} />
        <Routes>
          <Route path="/" element={<Home onQuoteClick={handleQuoteClick} />} />
          <Route path="/about" element={<About onQuoteClick={handleQuoteClick} />} />
          <Route path="/products" element={<Products onQuoteClick={handleQuoteClick} />} />
          <Route path="/services" element={<Services onQuoteClick={handleQuoteClick} />} />
          <Route path="/why-choose-us" element={<WhyChooseUs onQuoteClick={handleQuoteClick} />} />
          <Route path="/gallery" element={<Gallery onQuoteClick={handleQuoteClick} />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <QuoteModal
          isOpen={isQuoteModalOpen}
          onClose={() => setIsQuoteModalOpen(false)}
        />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
